export const images = {
  logo: 'HausHeld-Logo',
  logoAufzugo: 'Aufzugo-Logo',
  logoVermando: 'Vermando-Logo',
  swissMadeSoftware: 'swiss made software',
  altSealApprovedPartners: 'Geprüfte Partner',
  altMediaTagesAnzeiger: 'Tagesanzeiger-Logo',
  altMediaTagblatt: 'Tagblatt-Logo',
  altMediaDieOstschweiz: 'Die Ostschweiz-Logo',
  altMediaSwissPropTech: 'SwissPropTech-Logo',
  altMediaTVO: 'TVO-Logo',
  altMediaSwissSmartMedia: 'Swiss Smart Media-Logo',
  altHowItWorks1: `Wie funktioniert's`,
  altHowItWorks2: `Wie funktioniert's`,
  altHowItWorks3: `Wie funktioniert's`,
  altAdvantages1: 'Ihre Vorteile',
  altAdvantages2: 'Ihre Vorteile',
  altAdvantages3: 'Ihre Vorteile',
  altSwissFlag: 'Schweizer Fahne',
  altIconSealSaveRed: 'Siegel sparen rot',
  altIconSwissPortal: 'Schweizer Portal',
  altIconGermanPortal: 'Deutsches Portal',
  altMyHausHeld: 'myHausHeld',
  altMyHausHeldCellPhone: 'Smart Phone mit Gebäudeanalyse',
  altGoogleRating: 'Google-Bewertung',
  altLandingFammily: 'Bild einer Familie',
  altHausHeldMap: 'Google-Maps Karte von der Vermando AG',
  altPartnerQuality: 'Anfragen mit Qualität',
  altPartnerSaveTime: 'Zeit sparen',
  altPartnerObligations: 'Keine Verpflichtungen',
  altPartnerCosts: 'Transparente Kosten',
  altPartnerContacts: 'Kontakte knüpfen',
  altPartnerOffers: 'Hochwertige Aufträge',
  altPartnerCreate: 'Profil erstellen',
  altPartnerBudget: 'Budget festlegen',
  altPartnerInquiry: 'Anfrage erhalten',
  altPartnerWin: 'Aufträge gewinnen',
  altPartnerTest: 'Testphase starten',
  altPartnerBackend: 'Persönlicher Backendzugang',
  altPartnerGetInquiry: 'Anfragen erhalten',
  altPartnerInterest: 'Kein Interesse mehr?',
  altPartnerConvinced: 'Überzeugt?',
  switzerlandMap: 'Schweizer-Karte',
  germanyMap: 'Deutschlandkarte',
  altPartnerLaptop: 'Laptop',
  altPartnerHeroSmartphone: 'Helden Smartphone',
  testimonialImage1: 'Kundenbild 1',
  testimonialImage2: 'Kundenbild 2',
  altStepOne: 'Schritt 1',
  altStepTwo: 'Schritt 2',
  altStepThree: 'Schritt 3',
  altStepFour: 'Schritt 4',
  altStepFive: 'Schritt 5',
  altPartnerWoman: 'Bild von einer Handwerkerin',
  altFaqPlus: 'Plus Icon',
  altThanksCheck: 'Haken',
  altCheck: 'Haken',
  altSave30Percent: 'Discount-Icon',
  altQualityPartners: 'Icon Schweizerfahne',
  altGermanQualityPartners: 'Icon Deutschlandfahne',
  altFree: 'Icon Haken',
  altCounselorBanner: 'Ratgeber-Bannerbild',
  altPoweredByHausHeld: 'Powered by HausHeld-Logo',
  altMinergie: 'Minergie Logo',
  altWir: 'WIR Logo',
  altSwissmade: 'Swiss Made Logo',
  altSpinoff: 'Spin Off Logo',
  altCoop: 'Coop Bau & Hobby Logo',
  altStartfeld: 'Start Feld Logo',
  altMoneypark: 'Money Park Logo',
  wirPartnerBanner: 'Partner-Banner der Wir-Seite',
  mhLogo: 'myHausHeld - Logo',
  projectsIcon: 'Projekte Icon',
  analysisIcon: 'Analyse Icon',
  craftsmenIcon: ' Handwerker Icon',
  toolsIcon: 'Tools Icon',
  notificationIcon: 'Nachrichten Icon',
  userSettingsIcon: 'Benutzereinstellungen Icon',
  projectsEmptyCellPhone: 'Mobiltelefon mit der Ansicht eines Projektes',
  analysisEmptyCellPhone: 'Mobiltelefon mit der Ansicht der Gebäude-Analyse',
  craftsmenEmptyCellPhone: 'Mobiltelefon mit der Ansicht der Handwerker',
  brokerAlt: 'Bild eines Maklers',
  awningsAlt: 'Bild von Markisen',
  rollerBlindsAlt: 'Bild von Rolladen',
  painterAlt: 'Bild eines Malers',
  floorerAlt: 'Bild eines Bodenlegers',
  isolationAlt: 'Bild einer Isolation/Fassade',
  waterConditioningAlt: 'Bild der Wasseraufbereitung',
  airConditioningAlt: 'Bild einer Klimaanlage',
  paverAlt: 'Bild eines Plattenlegers',
  carpenterAlt: 'Bild eines Schreiners',
  assemblingAlt: 'Bild eines Monteurs',
  chippieAlt: 'Bild eines Zimmermanns',
  railingAlt: 'Bild eines Geländers',
  stairsAlt: 'Bild eine Treppe',
  balconyAlt: 'Bild eines Balkons',
  pergolaAlt: 'Bild einer Pergola',
  electricianAlt: 'Bild eines Elektrikers',
  gardenerAlt: 'Bild eines Gärtners',
  architectAlt: 'Bild eines Architekten',
  windowAlt: 'Bild eines Fensters',
  bathAlt: 'Bild eines Bades',
  heatingAlt: 'Bild einer Heizung',
  kitchenAlt: 'Bild einer Küche',
  solarAlt: 'Bild einer Solaranlage',
  carportAlt: 'Bild eines Carports',
  whirlpoolAlt: 'Bild eines Whirlpools',
  garageAlt: 'Bild einer Garage',
  wintergardenAlt: 'Bild eines Wintergartens',
  rooferAlt: 'Bild eines Dachdeckers',
  fenceAlt: 'Bild eines Zauns',
  customAlt: 'Bild des Benutzderdefinierten Projektes',
  metalConstructionAlt: 'Bild eines Schweissers',
  landingPageCouple: 'Bild eines Paares',
  landingPageProjects: 'Bild der Projektübersicht',
  landingPageEnergySaving: 'Bild der Energie-Ersparnisse',
  landingPageFinance: 'Mobiltelefon mit der Ansicht der Finanzcockpits',
  landingPageTaxSaving: 'Bild der Steuer-Ersparnisse',
  landingPageBadge1: 'Bild des Datenschutz-Badges',
  landingPageBadge2: 'Bild des Sichere-Hausanalyse-Badges',
  landingPageBadge3: 'Bild des Made-in-Switzerland-Badges',
  landingPageBadge4: 'Bild des Swiss-made-Software-Badges',
  houseIcon: 'Haus Icon',
  houseInfoIcon: 'Haus Info Icon',
  builderIcon: 'Bauarbeiter Icon',
  phoneIcon: 'Telefon Icon',
  mailIcon: 'Mail Icon',
  formsIcon: 'Formular Icon',
  toDoIcon: 'To-do Icon',
  documentationIcon: 'Dokumentations Icon',
  loadingIcon: 'Laden Icon',
  calendarIcon: 'Kalender Icon',
  editIcon: 'Bearbeiten Icon',
  deleteIcon: 'Löschen Icon',
  moneyParkIcon1: 'Bild des MoneyPark-Icons',
  moneyParkIcon2: 'Bild des MoneyPark-Icons',
  analysisHouse: 'Bild eines Hauses',
  hausHeldIcon: 'Logo von einem HausHeld-Handwerker',
  craftsmanAlt: 'Handwerker-Icon',
  appointmentAlt: 'Termin-Icon',
  renovationAlt: 'Renovations-Icon',
  analysisAlt: 'Gebäudeanalyse-Icon',
  altManage: 'Renovationsprojekte managen Icon',
  altIdentify: 'Identifizieren Icon',
  altRealEstate: 'Immobilie erfassen Icon',
  alarmsystemAlt: 'Bild einer Alarmanlage',
  propertyValueAlt: 'Bild eines Hauses mit Geld',
  chargingcolumnAlt: 'Bilder einer Ladesäule',
  appointmentIcon: 'Termin-Icon',
  altCooperationWir: 'In Zusammenarbeit mit Bank WIR',
  altDownload: 'Download-Icon',
  altMail: 'Mail-Icon',
  altContract: 'Vertrags-Icon',
  altMoney: 'Geld-Icon',
  brokerImage: 'Bild von Maklern',
  checkIconAlt: 'HausHeld-Haken Icon',
  altAufzugoEfficiency: 'Aufzugo-Effizienz Icon',
  altAufzugoPricePerformance: 'Aufzugo-Preis-Leistung Icon',
  altAufzugoQuality: 'Aufzugo-Qualitäts Icon',
  altAufzugoFree: 'Aufzugo-Gratis Icon',
  altAufzugoAllElevators: 'Alle Liftanlagen Icon',
  altAufzugoElevatorMaintenance: 'Bild einer Aufzugswartung',
  altAufzugoElevatorModernization: 'Bild einer Aufzugsmodernisierung',
  altAufzugoElevatorEmergencyCall: 'Bild eine Aufzuges mit Notruf',
  altAufzugoElevatorNewConstruction: 'Bild eines Aufzugsneubaues',
  altTargetMailing: 'Target-Mailing Bild',
  altSiteSponsoring: 'Branchenseiten-Verknüpfungs Bild',
  altBrokerHouses: 'Gebäude in Luzern',
  reminderBell: 'Erinnerungsglocke',
  altSwissLifeOffer: 'Angebot von Swiss Life',
  altSwissLifeLogo: 'Logo von Swiss Life',
  altFixedMortgage: 'Fix-Hypothek',
  coins: 'Münzen',
  approvedShield: 'Schild mit Häkchen',
  altFinanceCounselorBanner: 'Tür mit steckendem Schlüssel',
  altJumboLogo: 'Logo von Jumbo',
  altWirLogo: 'Logo von Wir',
  altMinergieLogo: 'Logo von Minergie',
  altLaptop: 'Bild von Laptop',
  altTablet: 'Bild von Tablet',
  altSmartWatch: 'Bild von SmartWatch',
  altMac: 'Bild von Mac',
  altIPhone: ' Bild von iPhone',
  altSecureComputer: 'Bild eines sicheren Computer',
  altIPad: 'Bild von iPad',
}
